import React, { useEffect, useState } from 'react';
import { AlertTriangleIcon, ArrowRightIcon, SparklesIcon } from 'lucide-react';
export function Hero() {
  const [typedText, setTypedText] = useState('');
  const fullText = 'Most AI automation fails because it automates the wrong things.';
  useEffect(() => {
    let index = 0;
    const timer = setInterval(() => {
      if (index <= fullText.length) {
        setTypedText(fullText.slice(0, index));
        index++;
      } else {
        clearInterval(timer);
      }
    }, 8);
    return () => clearInterval(timer);
  }, []);
  return <div className="relative w-full min-h-screen bg-black overflow-hidden flex items-center" data-id="element-307">
      {/* Animated grid background */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'linear-gradient(#ffa500 1px, transparent 1px), linear-gradient(90deg, #ffa500 1px, transparent 1px)',
      backgroundSize: '50px 50px',
      animation: 'gridMove 20s linear infinite'
    }} data-id="element-308" />
      {/* Floating particles */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-309">
        {[...Array(20)].map((_, i) => <div key={i} className="absolute w-1 h-1 bg-amber-500 rounded-full animate-float" style={{
        left: `${Math.random() * 100}%`,
        top: `${Math.random() * 100}%`,
        animationDelay: `${Math.random() * 5}s`,
        animationDuration: `${5 + Math.random() * 10}s`,
        opacity: Math.random() * 0.5 + 0.3
      }} data-id="element-310" />)}
        {[...Array(15)].map((_, i) => <div key={`green-${i}`} className="absolute w-1 h-1 bg-green-500 rounded-full animate-float" style={{
        left: `${Math.random() * 100}%`,
        top: `${Math.random() * 100}%`,
        animationDelay: `${Math.random() * 5}s`,
        animationDuration: `${5 + Math.random() * 10}s`,
        opacity: Math.random() * 0.5 + 0.3
      }} data-id="element-311" />)}
      </div>
      {/* Glowing orbs with enhanced animation */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-amber-500 rounded-full blur-[150px] opacity-20 animate-pulse-slow" data-id="element-312" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-green-500 rounded-full blur-[150px] opacity-20 animate-pulse-slow" style={{
      animationDelay: '1s'
    }} data-id="element-313" />
      {/* Enhanced scanline effect */}
      <div className="absolute inset-0 bg-repeat opacity-5 pointer-events-none animate-scanline" style={{
      backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 2px, #00ff00 2px, #00ff00 4px)'
    }} data-id="element-314" />
      {/* Glitch overlay */}
      <div className="absolute inset-0 pointer-events-none animate-glitch opacity-10" data-id="element-315" />
      <div className="relative z-10 container mx-auto px-6 py-20" data-id="element-316">
        <div className="max-w-6xl mx-auto" data-id="element-317">
          {/* Warning badge with glow */}
          <div className="mb-8 inline-flex items-center gap-2 px-4 py-2 border-2 border-amber-500 bg-black/80 backdrop-blur-sm animate-border-glow" data-id="element-318">
            <AlertTriangleIcon className="w-5 h-5 text-amber-500 animate-pulse" data-id="element-319" />
            <span className="text-amber-500 text-sm font-mono tracking-wider" data-id="element-320">
              UNCOMFORTABLE_TRUTH.TXT
            </span>
          </div>
          {/* Main message with typing effect */}
          <div className="mb-16" data-id="element-321">
            <h1 className="text-5xl md:text-7xl font-bold text-amber-500 mb-10 leading-tight" data-id="element-322">
              {typedText}
              <span className="animate-blink" data-id="element-323">|</span>
            </h1>
            <div className="max-w-3xl space-y-4" data-id="element-324">
              <p className="text-2xl text-green-400 font-semibold animate-fade-in-up" style={{
              animationDelay: '0.4s'
            }} data-id="element-325">
                We don't build what you ask for.
              </p>
              <p className="text-xl text-amber-100 leading-relaxed animate-fade-in-up" style={{
              animationDelay: '0.5s'
            }} data-id="element-326">
                We challenge it, delete what doesn't matter, simplify what's
                left, accelerate delivery—and only then apply AI automation.
              </p>
            </div>
          </div>
          {/* Stats Grid with stagger animation */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-12" data-id="element-327">
            {[{
            icon: SparklesIcon,
            label: 'AI IMPACT',
            value: '$50K+',
            desc: 'Profit per AI workflow',
            color: 'green',
            delay: '0.6s'
          }, {
            icon: SparklesIcon,
            label: 'ROI SPEED',
            value: '<90d',
            desc: 'To profitability',
            color: 'amber',
            delay: '0.65s'
          }, {
            icon: SparklesIcon,
            label: 'EFFICIENCY',
            value: '10×',
            desc: 'Workflow throughput',
            color: 'green',
            delay: '0.7s'
          }, {
            icon: SparklesIcon,
            label: 'DEPLOYMENT',
            value: 'ZERO',
            desc: 'Bureaucracy',
            color: 'amber',
            delay: '0.75s'
          }].map((stat, index) => <div key={index} className={`border-2 ${stat.color === 'green' ? 'border-green-500' : 'border-amber-500'} bg-black/80 backdrop-blur-sm p-6 animate-fade-in-up hover:scale-105 transition-transform duration-300`} style={{
            animationDelay: stat.delay
          }} data-id="element-328">
                <div className="flex items-center gap-2 mb-2" data-id="element-329">
                  <stat.icon className={`w-5 h-5 ${stat.color === 'green' ? 'text-green-400' : 'text-amber-400'} animate-pulse`} data-id="element-330" />
                  <span className={`text-xs ${stat.color === 'green' ? 'text-green-300' : 'text-amber-300'} font-mono`} data-id="element-331">
                    {stat.label}
                  </span>
                </div>
                <div className={`text-4xl font-bold ${stat.color === 'green' ? 'text-green-400' : 'text-amber-400'} font-mono mb-1`} data-id="element-332">
                  {stat.value}
                </div>
                <div className={`text-sm ${stat.color === 'green' ? 'text-green-300' : 'text-amber-300'}`} data-id="element-333">
                  {stat.desc}
                </div>
              </div>)}
          </div>
          {/* Brand badge and CTA section with animation */}
          <div className="border-4 border-amber-600 bg-black/90 backdrop-blur-sm p-8 shadow-[0_0_50px_rgba(255,165,0,0.4)] animate-fade-in-up hover:shadow-[0_0_80px_rgba(255,165,0,0.6)] transition-shadow duration-300" style={{
          animationDelay: '0.8s'
        }} data-id="element-334">
            <div className="flex flex-col lg:flex-row items-center justify-between gap-8" data-id="element-335">
              {/* Brand */}
              <div data-id="element-336">
                <h2 className="text-3xl font-bold text-amber-500 font-mono mb-2" data-id="element-337">
                  DILBERT RATIO GROUP
                </h2>
                <p className="text-green-400 font-mono text-lg mb-4" data-id="element-338">
                  AI AUTOMATION PARTNERS, NOT VENDORS
                </p>
                <p className="text-amber-100 text-sm max-w-md leading-relaxed" data-id="element-339">
                  We apply AI to workflows that drive profit—not just features
                  that look impressive in demos.
                </p>
              </div>
              {/* CTA */}
              <a href="https://www.linkedin.com/in/dawsonsewell" target="_blank" rel="noopener noreferrer" className="flex-shrink-0 inline-flex items-center gap-3 bg-amber-600 hover:bg-amber-500 text-black font-bold py-5 px-10 transition-all duration-200 border-4 border-amber-400 shadow-[0_0_30px_rgba(255,165,0,0.6)] hover:shadow-[0_0_50px_rgba(255,165,0,0.9)] group text-xl whitespace-nowrap animate-pulse-glow" data-id="element-340">
                <span className="tracking-wider" data-id="element-341">START THE CONVERSATION</span>
                <ArrowRightIcon className="w-6 h-6 group-hover:translate-x-2 transition-transform" data-id="element-342" />
              </a>
            </div>
          </div>
          {/* Value proposition */}
          <div className="mt-8 text-center animate-fade-in-up" style={{
          animationDelay: '0.9s'
        }} data-id="element-343">
            <p className="text-green-400 text-sm font-mono" data-id="element-344">
              // AI-POWERED WORKFLOWS THAT ACTUALLY DRIVE PROFIT
            </p>
          </div>
        </div>
      </div>
      <style data-id="element-345">{`
        @keyframes gridMove {
          0% {
            transform: translate(0, 0);
          }
          100% {
            transform: translate(50px, 50px);
          }
        }
        @keyframes float {
          0%, 100% {
            transform: translateY(0) translateX(0);
          }
          50% {
            transform: translateY(-100px) translateX(50px);
          }
        }
        @keyframes pulse-slow {
          0%, 100% {
            opacity: 0.15;
            transform: scale(1);
          }
          50% {
            opacity: 0.25;
            transform: scale(1.1);
          }
        }
        @keyframes scanline {
          0% {
            transform: translateY(0);
          }
          100% {
            transform: translateY(100vh);
          }
        }
        @keyframes glitch {
          0%, 100% {
            transform: translate(0);
          }
          33% {
            transform: translate(-2px, 2px);
          }
          66% {
            transform: translate(2px, -2px);
          }
        }
        @keyframes border-glow {
          0%, 100% {
            box-shadow: 0 0 10px rgba(255, 165, 0, 0.3);
          }
          50% {
            box-shadow: 0 0 20px rgba(255, 165, 0, 0.6);
          }
        }
        @keyframes blink {
          0%, 50% {
            opacity: 1;
          }
          51%, 100% {
            opacity: 0;
          }
        }
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes pulse-glow {
          0%, 100% {
            box-shadow: 0 0 30px rgba(255, 165, 0, 0.6);
          }
          50% {
            box-shadow: 0 0 50px rgba(255, 165, 0, 0.9);
          }
        }
        .animate-float {
          animation: float linear infinite;
        }
        .animate-pulse-slow {
          animation: pulse-slow 4s ease-in-out infinite;
        }
        .animate-scanline {
          animation: scanline 8s linear infinite;
        }
        .animate-glitch {
          animation: glitch 0.3s infinite;
        }
        .animate-border-glow {
          animation: border-glow 2s ease-in-out infinite;
        }
        .animate-blink {
          animation: blink 1s step-end infinite;
        }
        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out forwards;
          opacity: 0;
        }
        .animate-pulse-glow {
          animation: pulse-glow 2s ease-in-out infinite;
        }
      `}</style>
    </div>;
}